import { useContext, useEffect, useState } from "react";
import { ClientDetailContext } from "../../context/ClientDetailContext";
import ProviderListv2 from "./ProviderListv2";
import { useProCliStore } from "./hooks/useProCliStore";
import useService from "../../../../../../../hooks/useService";
import { useParams } from "react-router-dom";
import { DEFAULT_PAGINATION_LIMIT } from "../../../../../../../../globalConstants";

const ProviderListv2Wrapper = ({ caseInfo }) => {
  const { reFetchStaticBar, setReFetchStaticBar } = useContext(ClientDetailContext);
  const [providerInfoObj, setProviderInfoObj] = useState(null);
  const [providerClientRecCount, setProviderClientRecCount] = useState(0);
  const { limit, setLimit, shouldFetchData, setShouldFetchData, orderingVal} = useProCliStore();
  const providerClientRepository = useService('repositories/provider-client-status-repository');
  const { id } = useParams();

  useEffect(()=>{
    setLimit(DEFAULT_PAGINATION_LIMIT);
  },[]);

  useEffect(() => {
    const fetchProviderInfo = async () => {
      try {
        const providerClientObj = await providerClientRepository.query({ case: id, limit: limit, ordering: orderingVal });
        const providerClientRecCount =
        await providerClientRepository.getTotalCount();
        setProviderInfoObj(providerClientObj);
        setProviderClientRecCount(providerClientRecCount);
      } catch (error) {
      } finally {
        setShouldFetchData(false);
      }
    };
    fetchProviderInfo();
  }, [id, limit, shouldFetchData]);
  
  return (
    <div className="max-h-screen overflow-y-auto">
        {providerInfoObj && (
          <ProviderListv2
            caseInfo={caseInfo}
            setReFetchStaticBar={setReFetchStaticBar}
            providerInfo={providerInfoObj}
            count = {providerClientRecCount}
          />
        )}
    </div>
  );
  
}
export default ProviderListv2Wrapper;
